import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $bfc6f2d60b8a4c40$export$15010ca3c1abe90b = /*#__PURE__*/function () {
  function $bfc6f2d60b8a4c40$export$15010ca3c1abe90b(collection, direction, orientation) {
    var disabledKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Set();

    _classCallCheck(this, $bfc6f2d60b8a4c40$export$15010ca3c1abe90b);

    this.collection = collection;
    this.flipDirection = direction === 'rtl' && orientation === 'horizontal';
    this.disabledKeys = disabledKeys;
    this.tabDirection = orientation === 'horizontal';
  }

  return _createClass($bfc6f2d60b8a4c40$export$15010ca3c1abe90b, [{
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      if (this.flipDirection) return this.getNextKey(key);
      return this.getPreviousKey(key);
    }
  }, {
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      if (this.flipDirection) return this.getPreviousKey(key);
      return this.getNextKey(key);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled(key) {
      var _this_collection_getItem_props, _this_collection_getItem;

      return this.disabledKeys.has(key) || !!((_this_collection_getItem = this.collection.getItem(key)) === null || _this_collection_getItem === void 0 ? void 0 : (_this_collection_getItem_props = _this_collection_getItem.props) === null || _this_collection_getItem_props === void 0 ? void 0 : _this_collection_getItem_props.isDisabled);
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey() {
      var key = this.collection.getFirstKey();
      if (key != null && this.isDisabled(key)) key = this.getNextKey(key);
      return key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey() {
      var key = this.collection.getLastKey();
      if (key != null && this.isDisabled(key)) key = this.getPreviousKey(key);
      return key;
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      if (this.tabDirection) return null;
      return this.getPreviousKey(key);
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      if (this.tabDirection) return null;
      return this.getNextKey(key);
    }
  }, {
    key: "getNextKey",
    value: function getNextKey(startKey) {
      var key = startKey;

      do {
        key = this.collection.getKeyAfter(key);
        if (key == null) key = this.collection.getFirstKey();
      } while (key != null && this.isDisabled(key));

      return key;
    }
  }, {
    key: "getPreviousKey",
    value: function getPreviousKey(startKey) {
      var key = startKey;

      do {
        key = this.collection.getKeyBefore(key);
        if (key == null) key = this.collection.getLastKey();
      } while (key != null && this.isDisabled(key));

      return key;
    }
  }]);
}();

export { $bfc6f2d60b8a4c40$export$15010ca3c1abe90b as TabsKeyboardDelegate };